import { Chip, FormControl, FormHelperText, Grid, IconButton, Input, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
export default function AddIPs({ formik }) {
    const [currValue, setCurrValue] = useState(null);
  
    const handleChange = (event) => {
        const { value, name } = event.target;
        const maxCharacters = 15; // Max length for IPv4 (e.g., "255.255.255.255")
    
        // Allow only numbers and dots
        const filteredValue = value.replace(/[^0-9.]/g, "");
    
        // IPv4 validation: 0-255.0-255.0-255.0-255
        const isValidIPv4 = (ip) => {
            const octets = ip.split(".");
            if (octets.length !== 4) return false;
            return octets.every((octet) => {
                if (octet === "") return false;
                const num = Number(octet);
                return num >= 0 && num <= 255 && /^[0-9]+$/.test(octet);
            });
        };
    
        if (filteredValue.length > maxCharacters) {
            formik.setFieldError(name, `Only ${maxCharacters} characters are allowed.`);
            return;
        }
    
        if (filteredValue && !isValidIPv4(filteredValue)) {
            formik.setFieldError(name, "Invalid IPv4 Address format.");
        } else {
            formik.setFieldError(name, "");
        }
    
        setCurrValue(filteredValue);
    };
    

    const addIPs = () => {
        if (formik.values.ipAddresses.includes(currValue)) {
            formik.setFieldError("ipAddresses", `IP already exist.`);
            return;
        }
        formik.setFieldValue("ipAddresses", [...formik.values.ipAddresses, currValue]);
        setCurrValue("");
    };

    const handleDelete = (item, index) => {
        let arr = [...formik.values.ipAddresses];
        arr.splice(index, 1);
        formik.setFieldValue("ipAddresses", arr);
    };

    return (
        <Grid container display={"flex"} width={"100%"}>
            <Grid item  md={6}>
                <Typography className="text-muted mb-2">IP should be 15 numeric.</Typography>

                <div>
                    {formik.values?.ipAddresses &&
                        formik.values?.ipAddresses.map((item, index) => (
                            <Chip
                                size="small"
                                onDelete={() => {
                                    handleDelete(item, index);
                                }}
                                label={item}
                                sx={{ marginBlock: "4px",marginRight:"8px" }}
                            />
                        ))}
                </div>
                <FormControl error={Boolean(formik.errors.ipAddresses)}>
                    <Grid>
                        <Input value={currValue} onChange={handleChange} placeholder="0.0.0.0" />

                        <IconButton onClick={addIPs} disabled={!currValue}>
                            <AddIcon />
                        </IconButton>
                    </Grid>
                    <FormHelperText>{formik.errors.ipAddresses}</FormHelperText>
                </FormControl>
            </Grid>
        </Grid>
    );
}
